/* eslint-disable import/prefer-default-export */

// Components
const initCharacterCount = require('./components/character-count/character-count')
const initCheckboxes = require('./components/checkboxes/checkboxes')
const initDetails = require('./components/details/details')
const initHeader = require('./components/header/header')
const initHeaderDropdown = require('./components/header-dropdown/header-dropdown')
const initNotification = require('./components/notification/notification')
const initQuickExit = require('./components/quick-exit/quick-exit')
const initRadios = require('./components/radios/radios')
const initSkipLink = require('./components/skip-link/skip-link')
const initStepByStep = require('./components/step-by-step/step-by-step')

require('./polyfills.js')

/**
 * Use this function to initialise hse-frontend components within a
 * given scope. This function is called by default with the document
 * element, but you can call it again later with a new DOM element
 * containing hse-frontend components which you wish to initialise.
 *
 * @param {HTMLElement} scope
 */
function initAll(scope) {
  initCharacterCount({ scope })
  initCheckboxes({ scope })
  initDetails({ scope })
  initRadios({ scope })
  initNotification({ scope })
  initHeaderDropdown({ scope })
  initQuickExit({ scope })
  initStepByStep({ scope })
}

// Initialize components
document.addEventListener('DOMContentLoaded', () => {
  initHeader()
  initSkipLink()

  initAll(document)
})

module.exports = {
  initAll
}
